import React, { useState, useEffect } from "react";
import {
  XIcon,
  SearchIcon,
  CheckCircleIcon,
  UserAddIcon,
  UserRemoveIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/solid";
import axios from "axios";
import backendService from "../services.js/backendService";
import { ToastContainer, toast } from "react-toastify";
import toastProp from "../global/toastProps";
import { ThreeDots } from "react-loading-icons";
import ReactTooltip from "react-tooltip";


function SearchUser({ closeSearchUser }) {
  const [userAdd, setUserAdd] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect( () => {
    async function getResults() {
      if (searchText.length > 0) {
        try {
          setLoading(true);
          setSearchLoading(true);
          const res = await axios.get(`${process.env.REACT_APP_URL}/search/${searchText}`, {
            headers: {
              "Content-Type": "application/json",
              "x-auth-token": backendService.getToken(),
            },
          });
          setLoading(false);
          setSearchLoading(false);
          setSearchResults(res.data.users);
         
        } catch (error) {
          console.log(error);
          setSearchLoading(false);
        }
      } else if (searchText.length < 0) {
        setSearchResults([]);
      } else {
        setSearchResults([]);
      }
    }
    getResults();
  }, [searchText, userAdd]);

  const handleAddFriend = async (friendId) => {
    const id = toast.loading("Sending Request ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/addfriend`,
        {
          friendId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setLoading(false);
      toast.update(id, toastProp("Friend Request Sent ...", true));
    
      return true;
    } catch (error) {
      toast.update(id, toastProp("Something went wrong ...", false));
      console.log(error);
      return false;
    }
  };

  const handleRemoveFriend = async (friendId) => {
    const id = toast.loading("Cancelling Request ...", { theme: "light" });
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/removefriendrequest`,
        {
          friendId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      setLoading(false);
      toast.update(id, toastProp("Friend Request Cancelled ...", true));
     
      return true;
    } catch (error) {
      toast.update(id, toastProp("Something went wrong ...", false));
      console.log(error);
      return false;
    }
  };

  return (
    <div className=" h-[90%] ">
      <ReactTooltip delayShow={500} delayHide={100} />

      {/* Search Input */}
      <div className=" h-[10%] flex items-center px-5  ">
        <div
          className="relative items-center w-full"
          data-tip="Type to search"
          data-place="bottom"
        >
          <div className="absolute inset-y-0 left-0 flex items-center pl-3">
            {!searchLoading ? (
              <SearchIcon
                className="absolute h-6 w-6 text-palette_color1"
                aria-hidden="true"
              />
            ) : (
              <ThreeDots
                className="absolute h-6 w-6  text-secondary  cursor-pointer "
                fill="#0077b6"
              />
            )}
          </div>
          <input
            type="text"
            name="search"
            id="search"
            autoComplete="off"
            className="font-robo border-[1px] border-palette_color1 block text-sm w-full pl-10 py-2 px-3 bg-white appearance-none rounded-xl text-primary placeholder-secondary focus:outline-none focus:z-10 sm:text-sm"
            placeholder="Find New People"
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </div>
      {/* Rows */}
      <div className="h-[90%] overflow-x-hidden overflow-y-auto scroll-smooth row_Overflow">
        {searchText.length > 0 && searchResults.length > 0 && !searchLoading ? (
          searchResults.map((item, index) => (
            <div
              key={item._id}
              className="flex cursor-pointer shadow  rounded-lg hover:bg-[#254441]  transition-all duration-500 hover:text-white border-secondary m-3 "
            >
              <div className=" px-2 h-[65px] flex items-center w-[20%]">
                <div className="">
                  <img
                    alt="Profile"
                    className="rounded-full h-[40px] w-[40px] cursor-pointer"
                    src={
                      item?.profilePicture
                        ? item.profilePicture
                        : require("../assets/boredApe.png")
                    }
                  />
                </div>
              </div>
              <div className="  flex w-full">
                <div className="flex justify-center items-center w-full">
                  <div className="flex w-full justify-between items-center  pr-6">
                    <div className="mr-4 pb-1">
                      <h3 className=" text-md font-robo ">
                        {item.firstname + " " + item.lastname}
                      </h3>
                      <h3 className=" text-xs font-robo opacity-70 -mt-1">
                        {"@" + item.username}
                      </h3>
                    </div>
                    <div>
                      {item.status === "pending" ? (
                        <div className="flex justify-center h-7 w-7 items-center hover:bg-palette_color2 hover:text-palette_color1x hover:rounded-full">
                          <UserRemoveIcon
                            aria-disabled={loading}
                            disabled={true}
                            className="text-red h-5 w-5 cursor-pointer"
                            aria-hidden="true"
                            onClick={async () => {
                              if (!loading) {
                                if (await handleRemoveFriend(item._id)) {
                                  
                                  setUserAdd(!userAdd);
                                }
                              }
                            }}
                          />
                        </div>
                      ) : item.status === "not friend" ? (
                        <div className="flex justify-center h-7 w-7   items-center  hover:bg-palette_color2 hover:text-palette_color1 hover:rounded-full ">
                          <UserAddIcon
                            className=" h-5 w-5  cursor-pointer"
                            aria-hidden="true"
                            onClick={async () => {
                              if (!loading) {
                                if (await handleAddFriend(item._id)) {
                        
                                  setUserAdd(!userAdd);
                                }
                              }
                            }}
                          />
                        </div>
                      ) : item.status === "accepted" ? (
                        <CheckCircleIcon
                          aria-disabled={loading}
                          disabled={true}
                          className="text-palette_color4 h-7 w-7"
                          aria-hidden="true"
                        />
                      ) : item.status === "requested" ? (
                        <div
                          className="flex justify-center h-9 w-9 items-center "
                          data-tip="Check your friend requests"
                          data-place="bottom"
                          title="Check your friend requests"
                        >
                          <ExclamationCircleIcon
                            aria-disabled={loading}
                            disabled={true}
                            className="text-yellow-400 h-7 w-7"
                            aria-hidden="true"
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : searchLoading ? (
          <div className="flex justify-center items-center">
            <p className="text-primary text-lg font-robo  mt-10">Loading ...</p>
          </div>
        ) : searchText.length === 0 ? (
          <div className="flex justify-center items-center">
            <p className="text-palette_color1 text-lg font-robo  mt-10">
              Search for users to add
            </p>
          </div>
        ) : (
          <div className="flex justify-center items-center">
            <p className="text-palette_color1 text-lg font-robo   mt-10">
              No search result
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchUser;
